"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const changePasswordTranslations = {
    changePassword: "Change Password",
    oldPassword: "Old Password",
    newPassword: "New Password",
    oldPasswordError: "Please enter old password",
    oldPasswordCriteriaError: "Old password should be between 8 and 25 characters",
    changePasswordSuccess: "Password changed successfully!",
};
exports.default = changePasswordTranslations;
